import React, { useEffect, useState } from 'react';
import Backdrop from "@mui/material/Backdrop";
import { Box, Button, Fade, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { global, input, news, sip } from "../translate";
import Utils from "../Utils";
import Api from "../Api";
import { useDispatch,useSelector } from "react-redux";
import { profileRequest } from "../store/actions/users";
import BootstrapCarousel from "./BootstrapCarousel";
import { style } from "../helpers/style";
import parse from 'html-react-parser';
import { toast } from 'react-toastify';
const { REACT_APP_SERVER } = process.env;
const langArr = ['en', 'ru', 'hy']
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'
function NewsBanner({ open, setOpen, list, setAsk }) {
    const [expanded, setExpanded] = useState(false);
    const [slideIndex, setSlideIndex] = useState(0);
    const [status, setStatus] = useState(0);
    const dispatch = useDispatch()
    const userData = useSelector((state) => state.users.userData)
    useEffect(() => {
        setStatus(!userData.news)
    },[userData])
    const handleStatistic = async(id) => {
        setExpanded(prev => {
            if (!prev) {
                // setAsk(id)
                Api.createStatistic(id).catch(console.error); // fire and forget or await here
                return !prev;
            }else{
                setAsk(id)

               
            }
        });
    }
    const handleNext = () => {
        if (slideIndex < list.length - 1) {
            setSlideIndex(slideIndex + 1);
        } else {
            setOpen(false);
        }
        setExpanded(false)
    };

    const handleStatusChange = async (status) => {
        try {
            setStatus(status)
            await Api.statusNews(status)
            await dispatch(profileRequest())
        } catch (e) {

        }
    }

    const handleBack = () => {
        if (slideIndex > 0) {
            setSlideIndex(slideIndex - 1);
        }
        setExpanded(false)

    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className="d-flex flex-row justify-content-between">
                        <Typography id="transition-modal-title" variant="h5" component="h2">
                            {news.news[+localStorage.getItem('atsLang') || 1]}
                        </Typography>
                        <span style={{ cursor: 'pointer' }} onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </span>
                    </div>
                    <div style={{ margin: '20px 0' }}>
                        <div className="d-flex justify-content-between">
                            <h5>
                                {list[slideIndex]['title_' + langArr[+localStorage.getItem('atsLang') - 1 || 0]]}
                            </h5>
                            <span>
                                {Utils.formatDate(list[slideIndex].date)}
                            </span>
                        </div>
                        <div className='d-flex align-items-end flex-column'>
                            <div className={expanded ? '' : 'clamp-wrapper'}>
                                {parse(Utils.bufferDecoder(
                                    list[slideIndex]['desc_' + langArr[+localStorage.getItem('atsLang') - 1 || 0]],
                                    'html'
                                ))}
                            </div>
                            <button className="learn_more" onClick={() => handleStatistic(list[slideIndex].id)}>
                                {expanded ? news.want[+localStorage.getItem('atsLang') || 1 ]: news.learn[+localStorage.getItem('atsLang') || 1]}
                            </button>
                        </div>
                        {list[slideIndex]['image_' + langArr[+localStorage.getItem('atsLang') - 1 || 0]].length?<BootstrapCarousel images={list[slideIndex]['image_' + langArr[+localStorage.getItem('atsLang') - 1 || 0]]} /> :null}
                    </div>
                    <div className="d-flex flex-row justify-content-between" style={{ marginTop: 20 }}>
                        <div>
                            <label className="d-flex flex-row">
                                <span className="news_title">{news.remind[+localStorage.getItem('atsLang') || 1]}</span>
                                <input
                                    type="checkbox"
                                    checked={status}
                                    onChange={(ev) => handleStatusChange(+ev.target.checked)} />
                            </label>
                        </div>
                        <div>
                            {slideIndex > 0 && (
                                <Button
                                    sx={{ color: color, }}
                                    onClick={handleBack}>{news.back[+localStorage.getItem('atsLang') || 1]}</Button>
                            )}
                            <Button
                                sx={{ backgroundColor: color, color: '#fff', '&:hover': { backgroundColor: '#388e3c' } }}
                                onClick={handleNext}>
                                {slideIndex < list.length - 1 ? news.next[+localStorage.getItem('atsLang') || 1] : news.ok[+localStorage.getItem('atsLang') || 1]}
                            </Button>
                        </div>
            

                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default NewsBanner;